var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5297 1.35364V21.6481H11.2201L5.80828 16.2363H2.02945C0.910536 16.2363 0 15.3257 0 14.2068V8.79494C0 7.67604 0.910536 6.7655 2.02945 6.7655H5.80828L11.2201 1.35364H13.5297ZM12.1767 2.7066H11.7803L6.76483 7.72204V15.2797L11.7803 20.2951H12.1767V2.70661V2.7066ZM20.0289 4.32515C21.9447 6.2423 23 8.78994 23 11.5013C23 14.2113 21.9447 16.7589 20.0289 18.6761L19.0723 17.7195C20.7338 16.0581 21.647 13.85 21.647 11.5013C21.647 9.15118 20.7338 6.94314 19.0723 5.2817L20.0289 4.32515ZM17.1645 7.1971C18.3105 8.35929 18.941 9.88815 18.941 11.5009C18.941 13.1136 18.3105 14.6425 17.1645 15.8047L16.1999 14.8549C17.0955 13.947 17.588 12.7564 17.588 11.5009C17.588 10.2453 17.0955 9.05472 16.1999 8.14688L17.1645 7.1971ZM5.41186 8.11846H2.02945C1.65738 8.11846 1.35296 8.42154 1.35296 8.79494V14.2068C1.35296 14.5802 1.65738 14.8833 2.02945 14.8833H5.41186V8.11846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.9ad1a28fba9703aff5e2e18c5ff7f6e8.svg";
export { ForwardRef as ReactComponent };